var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flow-flex-center jFlow" }, [
    _c(
      "div",
      { staticClass: "wrap" },
      [
        _c(
          "div",
          { staticClass: "bullet-center fl-right" },
          [
            _c("router-link", { attrs: { to: "/flows" } }, [
              _c("i", { staticClass: "fa fa-times" })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._l(_vm.flow, function(approver, index) {
          return _c("div", { key: index, staticClass: "approver-order" }, [
            index > 0
              ? _c("div", { staticClass: "bullet-center" }, [
                  _c("div", { staticClass: "line-empty half-line" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "header-flow" }, [
              _c("div", { staticClass: "header-actions" }, [
                _c("i", {
                  staticClass: "fa fa-edit",
                  on: {
                    click: function($event) {
                      _vm.editFlow(index)
                    }
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa fa-times",
                  on: {
                    click: function($event) {
                      _vm.removeFlow(index)
                    }
                  }
                })
              ]),
              _vm._v(
                "\n        Approver " + _vm._s(approver.order) + "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-flow" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    approver.organigram_name
                      ? approver.organigram_name.name
                      : ""
                  ) +
                  " "
              ),
              _c("br"),
              _vm._v(
                "\n        " +
                  _vm._s(
                    // eslint-disable-next-line max-len
                    approver.organigram_member_name
                      ? approver.organigram_member_name
                      : approver.organigram_name
                      ? // eslint-disable-next-line max-len
                        approver.organigram_name.user
                        ? approver.organigram_name.user.profile.first_name +
                          " " +
                          approver.organigram_name.user.profile.last_name
                        : ""
                      : ""
                  ) +
                  "\n      "
              )
            ])
          ])
        }),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bullet-center add-approver-flow" },
          [
            _c(
              "b-btn",
              {
                staticClass: "btn blue outline",
                on: { click: _vm.openAddApproverForm }
              },
              [_vm._v("\n        ADD APPROVER\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "flowApprover",
                staticClass: "mod-form",
                attrs: {
                  centered: "",
                  "no-close-on-backdrop": "",
                  "no-close-on-esc": ""
                }
              },
              [
                !_vm.edit_approver.status
                  ? _c(
                      "div",
                      {
                        staticClass: "close-modal-flow",
                        on: { click: _vm.closeAddApprover }
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "close-modal-flow",
                        on: { click: _vm.closeEdit }
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    ),
                _vm._v(" "),
                _vm.edit_approver.status
                  ? _c("div", { staticClass: "title-flow" }, [
                      _c("i", { staticClass: "fa fa-square" }),
                      _vm._v("\n          Edit Approver\n        ")
                    ])
                  : _c("div", { staticClass: "title-flow" }, [
                      _c("i", { staticClass: "fa fa-square" }),
                      _vm._v("\n          Add Approver\n        ")
                    ]),
                _vm._v(" "),
                _c(
                  "b-form-radio-group",
                  {
                    model: {
                      value: _vm.selected,
                      callback: function($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected"
                    }
                  },
                  [
                    _c(
                      "b-form-radio",
                      {
                        staticClass: "jFormGroup",
                        attrs: { value: "true", name: "Radios" }
                      },
                      [_vm._v("\n            Select Division*\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    class: {
                      "error-input": _vm.$v.v_addApprover.organigram_id.$error
                    }
                  },
                  [
                    _c("j-single-select", {
                      attrs: {
                        disabled: _vm.selected !== "true",
                        "is-async": true,
                        "load-options": _vm.loadOptionsDivision,
                        "value-format": "object",
                        label: "name",
                        placeholder: "All Division"
                      },
                      model: {
                        value: _vm.v_addApprover.organigram_id,
                        callback: function($$v) {
                          _vm.$set(_vm.v_addApprover, "organigram_id", $$v)
                        },
                        expression: "v_addApprover.organigram_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.selected === "true"
                  ? _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input":
                            _vm.$v.v_addApprover.organigram_name.$error
                        }
                      },
                      [
                        _c("label", [_vm._v("Select Position*")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          staticClass: "v-singleselect",
                          attrs: {
                            "is-async": true,
                            "load-options": _vm.loadOptionsPositionByDivision,
                            disabled: !_vm.v_addApprover.organigram_id,
                            "value-format": "object",
                            label: "name",
                            placeholder: "Select Position"
                          },
                          model: {
                            value: _vm.v_addApprover.organigram_name,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.v_addApprover,
                                "organigram_name",
                                $$v
                              )
                            },
                            expression: "v_addApprover.organigram_name"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.edit_approver.status
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-form-radio-group",
                          {
                            model: {
                              value: _vm.selected,
                              callback: function($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected"
                            }
                          },
                          [
                            _c(
                              "b-form-radio",
                              {
                                staticClass: "jFormGroup",
                                attrs: { value: "false", name: "Radios" }
                              },
                              [
                                _vm._v(
                                  "\n              Add Division*\n            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            class: {
                              "error-input":
                                _vm.$v.v_addDivision.division.$error
                            }
                          },
                          [
                            _c("j-input", {
                              attrs: {
                                disabled: _vm.selected === "true",
                                "max-length": 255,
                                placeholder: "Add New Division"
                              },
                              model: {
                                value: _vm.v_addDivision.division,
                                callback: function($$v) {
                                  _vm.$set(_vm.v_addDivision, "division", $$v)
                                },
                                expression: "v_addDivision.division"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.selected !== "true"
                          ? _c(
                              "b-form-group",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.v_addDivision.division_code.$error
                                }
                              },
                              [
                                _c("label", [_vm._v("Division Code*")]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: {
                                    "max-length": 255,
                                    placeholder: "Division Code"
                                  },
                                  model: {
                                    value: _vm.v_addDivision.division_code,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.v_addDivision,
                                        "division_code",
                                        $$v
                                      )
                                    },
                                    expression: "v_addDivision.division_code"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selected !== "true"
                          ? _c(
                              "b-form-group",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.v_addDivision.title.$error
                                }
                              },
                              [
                                _c("label", [_vm._v("Add Position*")]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: {
                                    "max-length": 255,
                                    placeholder: "Add Position"
                                  },
                                  model: {
                                    value: _vm.v_addDivision.title,
                                    callback: function($$v) {
                                      _vm.$set(_vm.v_addDivision, "title", $$v)
                                    },
                                    expression: "v_addDivision.title"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selected !== "true"
                          ? _c(
                              "b-form-group",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.v_addDivision.title_code.$error
                                }
                              },
                              [
                                _c("label", [_vm._v("Position ID*")]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: {
                                    "max-length": 255,
                                    placeholder: "Position ID"
                                  },
                                  model: {
                                    value: _vm.v_addDivision.title_code,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.v_addDivision,
                                        "title_code",
                                        $$v
                                      )
                                    },
                                    expression: "v_addDivision.title_code"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selected !== "true"
                          ? _c(
                              "b-form-group",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.v_addDivision.user.$error
                                }
                              },
                              [
                                _c("label", [_vm._v("Select User*")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  staticClass: "v-singleselect",
                                  attrs: {
                                    "is-async": true,
                                    "load-options": _vm.loadOptions,
                                    "value-format": "object",
                                    placeholder: "Select User",
                                    label: "email"
                                  },
                                  model: {
                                    value: _vm.v_addDivision.user,
                                    callback: function($$v) {
                                      _vm.$set(_vm.v_addDivision, "user", $$v)
                                    },
                                    expression: "v_addDivision.user"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wrap-button-flow" },
                  [
                    _vm.edit_approver.status
                      ? _c(
                          "b-button",
                          {
                            staticClass: "btn blue",
                            on: { click: _vm.saveEditFlow }
                          },
                          [_vm._v("\n            EDIT APPROVER\n          ")]
                        )
                      : _c(
                          "b-button",
                          {
                            staticClass: "btn blue",
                            on: { click: _vm.setApprover }
                          },
                          [_vm._v("\n            SET APPROVER\n          ")]
                        ),
                    _vm._v(" "),
                    !_vm.edit_approver.status
                      ? _c(
                          "b-button",
                          {
                            staticClass: "btn blue outline",
                            on: { click: _vm.clearSelectedApprover }
                          },
                          [_vm._v("\n            CLEAR\n          ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bullet-center" },
          [
            _vm.flow[0]
              ? _c(
                  "b-button",
                  {
                    staticClass: "btn blue",
                    on: {
                      click: function($event) {
                        _vm.$refs.saveFlow.show()
                      }
                    }
                  },
                  [_vm._v("Update")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            ref: "saveFlow",
            staticClass: "mod-form save-flow-approver",
            attrs: {
              "no-close-on-backdrop": "",
              "no-close-on-esc": "",
              centered: ""
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "close-modal-flow",
                on: {
                  click: function($event) {
                    _vm.$refs.saveFlow.hide()
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-times" })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "title-flow" }, [
              _c("i", { staticClass: "fa fa-square" }),
              _vm._v("\n        Update Flow\n      ")
            ]),
            _vm._v(" "),
            _c(
              "b-form-group",
              { class: { "error-input": _vm.$v.v_saveFlow.name.$error } },
              [
                _c("label", [_vm._v("Flow Name*")]),
                _vm._v(" "),
                _c("j-input", {
                  attrs: { "max-length": 50, placeholder: "ex: Flow-01" },
                  model: {
                    value: _vm.v_saveFlow.name,
                    callback: function($$v) {
                      _vm.$set(_vm.v_saveFlow, "name", $$v)
                    },
                    expression: "v_saveFlow.name"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { class: { "error-input": _vm.$v.v_saveFlow.type.$error } },
              [
                _c("label", [_vm._v("Flow Type*")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    options: _vm.flow_type,
                    placeholder: "Select Type",
                    "value-format": "object",
                    label: "name"
                  },
                  model: {
                    value: _vm.v_saveFlow.type,
                    callback: function($$v) {
                      _vm.$set(_vm.v_saveFlow, "type", $$v)
                    },
                    expression: "v_saveFlow.type"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "wrap-button-flow" },
              [
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveFlow } },
                  [_vm._v("\n          Update\n        ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bullet-center" }, [
      _c("h2", [_vm._v("Update Flow")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bullet-center" }, [
      _c("div", { staticClass: "flow-new__bullet-top" }, [
        _c("i", { staticClass: "fa fa-square" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bullet-center" }, [
      _c("div", { staticClass: "line-empty" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bullet-center" }, [
      _c("div", { staticClass: "line-empty half-line" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed2f71a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed2f71a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/flow/jFlowUpdate.vue
// module id = null
// module chunks = 